// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-challenge{
  padding:2rem;
  background-color:#fff;
  border-radius:0.25rem;
}
.mfa-challenge__back{
    display:inline-block;
    margin-bottom:1.5rem;
  }
.mfa-challenge h1{
    font-size:1.75rem;
    line-height:2.625rem;
    margin-bottom:0.5rem;
  }
@media (width <= 640px){
.mfa-challenge{
    padding:1.25rem
}

    .mfa-challenge .button{
      width:100%;
    }
  }
.mfa-challenge ftr-untyped-form{
    display:flex;
  }
.mfa-challenge ftr-untyped-form .form{
      display:flex;
      flex-basis:50%;
      flex-direction:column;
    }
@media (width <= 640px){
.mfa-challenge ftr-untyped-form .form{
        flex-basis:100%
    }
      }
.mfa-challenge ftr-untyped-form .form__footer{
      flex-direction:row;
      margin-top:1.5rem;
    }
@media (width <= 640px){
        .mfa-challenge ftr-untyped-form .form__footer .form__footer__submit{
          width:100%;
        }
      }
.mfa-challenge ftr-untyped-form .form__footer a{
        margin:0;
      }
.mfa-challenge__text{
    margin-bottom:1.5rem;
  }
.mfa-challenge__link{
    margin-top:1.5rem;
  }
.mfa-challenge .row{
    margin-left:0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
